export enum ExecutionType {
    Dry = 'dry',
    Normal = 'normal',
    Test = 'test',
    LongRunning = 'longRunning',
    Sample = 'sample',
}
